import {uniqueId} from 'lodash'

const routeToClientCard = {
  name: 'ContactCard',
  params: {
    id: 'id'
  },
  paramName: 'id',
  paramValue: 'client.id',
  props: true
}

const columns = [
  {
    title: 'PAID ON',
    type: 'date',
    prop: 'paymentDate',
    typeTable: 'kpiInfo',
    placeholder: 'N/A',
    info: {
      display: 'project.includeOfKpiComment',
      text: 'project.includeOfKpiComment'
    },
    padding: true,
    width: 'minmax(85px, 90px)'
  },
  {
    title: 'CLIENT',
    prop: 'client.name',
    route: routeToClientCard,
    hover: true,
    typeTable: 'kpiInfo',
    width: 'minmax(88px, 153px)'
  },
  {
    title: 'SERVICE',
    prop: 'service.name',
    nameRoute: 'ProjectCard',
    nameProject: {
      display: 'project.name',
      text: 'project.name'
    },
    checkRoute: 'serviceProjectManagerInstanceIdIsDelete',
    billet: {
      text: ['Dues paid', 'Split %'],
      display: ['isDouble', 'project.kpiHelpUsers.length']
    },
    enum: {
      prop: 'createType',
      getter: (val) => {
        switch (val) {
        case 2:
          return 'Proj'
        case 3:
          return 'Inv'
        default:
          return ''
        }
      }
    },
    width: 'minmax(182px, 243px)'
  },
  {
    title: 'PROFORMA NO.',
    prop: 'invoice.number',
    hover: true,
    actionType: 'openProforma',
    typeTable: 'kpiInfo',
    width: 'minmax(109px, 150px)'
  },
  {
    title: 'INVOICED',
    prop: 'amount',
    type: 'number',
    padding: true,
    width: 'minmax(57px, 103px)'
  },
  {
    title: 'RECEIVED',
    prop: 'currentValue',
    typeTable: 'kpiInfo',
    type: 'number',
    padding: true,
    width: 'minmax(62px, 156px)'
  },
  {
    title: 'FACT',
    prop: 'factValue',
    type: 'number',
    info: {
      display: 'project.managerComment',
      text: 'project.managerComment'
    },
    typeEditable: 'number',
    error: 'factError',
    notMore: 'assignedValue',
    width: 'minmax(57px, 125px)'
  },
  {
    title: 'ASSIGNED %',
    prop: 'assignedPercent',
    postfix: '%',
    center: true,
    width: '80px'
  },
  {
    title: 'COMPLETION DATE',
    prop: 'project.dateEnd',
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    typeTable: 'kpiInfo',
    padding: true,
    width: 'minmax(115px, 161px)'
  },
  {
    title: 'APPROVAL',
    prop: 'serviceIsApproved',
    editable: true,
    type: 'approveCell',
    actionType: 'setApprove',
    typeEditable: 'checkbox',
    mark: 'forApproval',
    typeTable: 'kpiInfo',
    center: true
  }
]

const prefix = 'kpi_potential_columns_'
const kpiPotentialColumns = columns.map(col => {
  col.mark = 'potential'
  col.id = uniqueId(prefix)
  return col
})

export default kpiPotentialColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/kpiPotentialTable.js